import { FieldValues, useFormContext } from 'react-hook-form';
import colors from 'tailwindcss/colors';

import { cn } from '@/lib/utils';

import { ItemStatusEnum, statusOptions } from '../constants';
import { Autocomplete, AutocompleteProps } from './autocomplete';

type ItemStatusProps = Pick<
  AutocompleteProps<FieldValues>,
  'isDisabled' | 'control' | 'name'
>;

export function ItemStatus({ isDisabled, name, control }: ItemStatusProps) {
  const { watch } = useFormContext();

  const status = watch(name) as ItemStatusEnum;

  return (
    <Autocomplete
      name={name}
      label="Status"
      isDisabled={isDisabled}
      control={control}
      options={statusOptions}
      placeholder="Select status"
      className={cn({
        'bg-green-500 hover:bg-green-500 text-zinc-900 hover:text-zinc-900':
          status === ItemStatusEnum.Ready,
        'bg-accent hover:bg-accent text-zinc-900 hover:text-zinc-900':
          status === ItemStatusEnum.Archived,
      })}
      iconColor={isDisabled ? undefined : colors.zinc[900]}
    />
  );
}
